import styled from 'styled-components';


const LoginWrapper = styled.div`
label{
  font-family: 'OpenSans';
  color: #4c565c;
  font-weight: bold;
  font-size: 13px;
}
.fit{
    // margin-top: 40vh;
    bottom: 55px;
    position: fixed;
    width: 100%;
}
.vehicle-wrapper{
    background-image: linear-gradient(to bottom, #f9fdff 0%, rgba(249, 253, 255, 0) 100%), linear-gradient(to bottom, #fff, #fff);
}

.vehical-section {
    margin-top: 20px;
    margin-bottom: 10px;
}
.policy-section {
    margin-top: 20px;
    margin-bottom: 20px;
}

@media only screen and (max-width: 576px) {
    .fit{
        margin-top: 4rem;
        position:relative;
        bottom:0;

    }

  }

  .insured-wrapper {
    text-align:initial;
    label{
      font-family: 'OpenSans';
      color: #4c565c;
      font-weight: bold;
      font-size: 13px;
    }
    padding: 1rem 0;
    .retrieve{
        text-align:initial;
        font-size: 28px;
        color: #6B47F5; 
        font-weight: bold;      
        span{ color: #4c565c;display:block;}
    }
    .add_wrapper {
      background-color: #eef2f5;
    }
    .form-wrapper {
      // width: 100%;
      // display: flex;
      // flex-direction: column;
      // justify-content: flex-start;
      // align-items: flex-start;
      padding: 2rem 1rem 1rem;
    }
  
    @media only screen and (max-width: 768px) {
      .add_wrapper {
        border-radius: 10px;
      }
    }
  
    .ar {
      label{
        font-family: 'GESS' !important;
      }
    }

    .row {
      margin-bottom: 80px;
    }

    .textContainer {
      display: flex;
      justify-content: center;
      flex-direction: column;
    }

    .homeInsureanceImage {
      max-width: 100%;
      height: auto;
    }
  }
`;


export default LoginWrapper;